export interface Appointment {
    id: string /** ID de la cita */;
    clinicID: string /** ID de la clínica donde está la cita */;
    clinicName: string /** Nombre de la clínica donde está la cita */;
    date: string /** Fecha de la cita */;
    timeStart: string /** Hora de inicio del a cita */;
    timeEnd: string /** Hola de fin de la cita */;
    servicesDescription: string[] /** Descripción de los servicios que contiene la cita */;
}

/**
 * A factory function that creates Appointment
 */
export function createAppointment(params: Partial<Appointment>) {
    return {} as Appointment;
}

/**
 * Factoría que crea una Appointment con los datos recogidos por la API
 */
export function appointmentFactory(params: any) {
    return {
        id: params.AppId,
        clinicID: params.AppClinicID,
        clinicName: params.AppClinicName,
        date: params.AppDate,
        timeStart: params.AppTimeStart,
        timeEnd: params.AppTimeEnd,
        servicesDescription: params.AppServicesDescription.split(','),
    } as Appointment;
}
